import { Flex } from '@chakra-ui/react';
import moment from 'moment';
import { FaChevronCircleRight } from 'react-icons/fa';

import { Txt } from '@app/components/common';
import { TableColumn } from '@app/components/common/table';
import { USER_DATE_TIME_FORMAT } from '@app/utils';
import { TransactionPackage, TransactionPackageDetail } from '@app/api/models/transaction';

import { Status } from './components/status';
import { TxTypeView } from './components/tx-type';

export const useColumns = ({ packageDetails, onShowPackageDetail }: {
  packageDetails?: Record<string, TransactionPackageDetail & { isCollapsed: boolean }>
  onShowPackageDetail?: (packageId: string) => void
}): TableColumn<TransactionPackage>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string) => {
          const { isCollapsed } = packageDetails?.[value] || { isCollapsed: true };
          return <Flex gap={2}>
            <FaChevronCircleRight 
              style={{
                transform: isCollapsed ? 'rotate(0deg)' : 'rotate(90deg)',
                transition: 'all 0.5s ease',
                cursor: 'pointer',
                color: 'var(--chakra-colors-brand-500)',
              }}
              size={18}
              onClick={(e) => {
                e.stopPropagation();
                onShowPackageDetail(value);
              }}
            />
            <Txt fontSize='sm' textColor='gray.500'>{value.slice(0, 5)}...{value.slice(-5)}</Txt>
          </Flex>;
        }
      }
    },
    {
      name: 'type',
      label: 'Тип',
      options: {
        filter: {
          name: 'type_id',
          type: 'select',
          sourceName: 'transaction_type',
        },
        sort: true,
        customBodyRender: (value) => {
          return <TxTypeView type={value} />;
        }
      }
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <Status status={value} />;
        }
      }
    },
    {
      name: 'create_dt',
      label: 'Дата создания',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <>{moment(value).format(USER_DATE_TIME_FORMAT)}</>;
        }
      }
    },
    {
      name: 'transfer_dt',
      label: 'Дата перемещения',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return <>{moment(value).format(USER_DATE_TIME_FORMAT)}</>;
        }
      }
    },
    {
      name: 'transactions_count',
      label: 'Количество транзакций',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          return <>{value}</>;
        }
      }
    },
    {
      name: 'equip_id',
      label: 'ID ХО',
      options: {
        hidden: true,
        filter: {
          name: 'equip_id',
          type: 'text',
        }
      }
    },
    {
      name: 'serial_num',
      label: 'Серийный номер',
      options: {
        hidden: true,
        filter: {
          name: 'serial_num',
          type: 'text',
        }
      }
    },
    {
      name: 'inventory_num',
      label: 'Инвентарный номер',
      options: {
        hidden: true,
        filter: {
          name: 'inventory_num',
          type: 'text',
        }
      }
    },
    {
      name: 'id_from',
      label: 'ID из TT',
      options: {
        hidden: true,
        filter: {
          name: 'id_from',
          type: 'outlet',
          sourceName: 'outlet',
        }
      }
    },
    {
      name: 'id_to',
      label: 'ID в TT',
      options: {
        hidden: true,
        filter: {
          name: 'id_to',
          type: 'outlet',
          sourceName: 'outlet',
        }
      }
    },
    {
      name: 'distributor_id',
      label: 'ID дистрибьютора',
      options: {
        hidden: true,
        filter: {
          name: 'distributor_id',
          type: 'autocomplete',
          sourceName: 'distributor',
        }
      }
    },
    {
      name: 'create_dt',
      label: 'Дата создания',
      options: {
        hidden: true,
        filter: {
          name: 'create_date_range',
          type: 'date-range',
          onApply: (value) => {
            return value.map((date) => date.split('T')[0]);
          }
        },
      },
    },
    {
      name: 'transfer_dt',
      label: 'Дата перемещения',
      options: {
        hidden: true,
        filter: {
          name: 'transfer_date_range',
          type: 'date-range',
          onApply: (value) => {
            return value.map((date) => date.split('T')[0]);
          }
        },
      },
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: {
          name: 'status_id',
          type: 'select',
          sourceName: 'transaction_status',
        },
        sort: false,
        hidden: true,
      }
    }
  ];
};